module.exports.run = function(EVENTS_MAP, exceptions = {}){

  var list = Object.keys(EVENTS_MAP)
    .reduce((acc, key) => {
      if(this[key]){
        let exception = exceptions[key];
        acc.push({
          date: this[key],
          title: (exception && exception.title) || EVENTS_MAP[key].title,
          icon: (exception && exception.icon) || EVENTS_MAP[key].icon
        });
      }
      return acc;
    }, 
    []
  );
  list.sort((a,b) => a.date > b.date);
  return list;
};